// privacy-policy.tsx
import React from "react";
import { Box, Typography, Container, Stack } from "@mui/material";

export default function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">
        Privacy Policy
      </Typography>

      <Stack spacing={4}>
        {/* Privacy Policy Content */}
        <Box>
          <Typography variant="body1" gutterBottom>
            Your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your information when you visit our website.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Information We Collect
          </Typography>
          <Typography variant="body1" gutterBottom>
            We may collect personal information such as your name, email address, and any other details you provide through contact forms or newsletter sign-ups. We also collect non-personal data like browser type, device information, and usage data through cookies and analytics tools.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            How We Use Your Information
          </Typography>
          <Typography variant="body1" gutterBottom>
            We use your information to:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>★ Respond to inquiries or provide requested services.</li>
            <li>★ Improve our website functionality and user experience.</li>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Cookies
          </Typography>
          <Typography variant="body1">
            Our site uses cookies to enhance your experience. You can choose to disable cookies through your browser settings.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Third-Party Services
          </Typography>
          <Typography variant="body1">
            We may use trusted third-party tools (e.g., Google Analytics) to collect and analyze data. These providers are bound by their own privacy policies.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Data Security
          </Typography>
          <Typography variant="body1">
            We take reasonable steps to protect your data from unauthorized access or disclosure, but no method of transmission is 100% secure.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Your Rights
          </Typography>
          <Typography variant="body1">
            You may request to access, correct, or delete your personal data by contacting us.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Changes to This Policy
          </Typography>
          <Typography variant="body1">
            We may update this policy from time to time. Changes will be posted on this page.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Contact Us
          </Typography>
          <Typography variant="body1">
            If you have any questions about this policy, please contact us.
          </Typography>
        </Box>

        {/* Return and Refund Policy Content */}
        <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">
          Return & Refund Policy
        </Typography>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Return Policy
          </Typography>
          <Typography variant="body1" gutterBottom>
            Return accepted only in case of wrong/defective product delivered.
          </Typography>
          <Typography variant="body1" gutterBottom>
            Parcel opening video is mandatory for claim.
          </Typography>
          <Typography variant="body1" gutterBottom>
            Follow the rules:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>★ Show the parcel followed by address and tracking detail.</li>
            <li>★ Open the parcel, take out products, and show them clearly.</li>
            <li>★ Take video without pause or cut.</li>
          </Typography>
          <Typography variant="body1" gutterBottom>
            Your refund or store credit will be issued within 7 days of our receipt.
          </Typography>
          <Typography variant="body1">
            Refunds will be issued to your form of payment for the order.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Product Cannot Be Returned On Following Grounds
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>★ Ordered by mistake.</li>
            <li>★ Product no longer needed.</li>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            No Returns
          </Typography>
          <Typography variant="body1" gutterBottom>
            All sales are final. We do not accept returns on any of our products once the order has been shipped. Please carefully review your order before completing your purchase.
          </Typography>
          <Typography variant="body1">
            We request our customers to check their orders carefully when delivered and report any damages/shortages immediately.
          </Typography>
        </Box>

        <Box>
          <Typography variant="body1" gutterBottom>
            In case of any damage, kindly inform within 2 days of receiving delivery; otherwise your complaint will not be taken into consideration. Customers will also have to send the opening video of the damaged product as proof via Email / Whatsapp - 7233034085.
          </Typography>
          <Typography variant="body1">
            You can cancel an order until it has not been shipped out of our Warehouse.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Non-Refundable Fee
          </Typography>
          <Typography variant="body1">
            Shipping fees are non-refundable, even in the case of damaged or defective products.
          </Typography>
        </Box>
      </Stack>
    </Container>
  );
}
